import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        // APP
        APP_VERSION: '1.0.1 / 14-10-2023.01',
        APP_TITLE: 'APP - Thalo Global Group',
        APP_LOGO: '/src/assets/images/logo.png',
        APP_AGENCIA: 'System',
        DEFAULT_LANGUAGE: 1,  
        ID_LANGUAGE: 1,
        TYPE_MENU: 'ME',
        DEFAULT_USER: 'a',
        DEFAULT_PASSWORD: 'a',

        // LOCAL STORAGE
        LS_USER_LOGIN: 'userLogin',
        LS_MENU_LABEL: 'menuLabel',
        LS_MENU_ICON: 'menuIcon',
        LS_MENU_CLICK: 'menuClick',
        

        // PRINT
        PROPERTIES_PRINT_LIST: { pageOrientation: 'portrait',
                                 pageSize: 'a4',
                                 format: 'list',
                                 fileName: ' (list)'
                               },
        PROPERTIES_PRINT_FORM: { pageOrientation: 'portrait',
                                 pageSize: 'a4',
                                 format: 'form',
                                 fileName: ' (form)'
                               },

        RESPONSE_CODE_OK: 200,
        TOTAL_RECORD_LIST: 13,
        CURRENT_RECORD: 0,

        // FORM
        FORM_LOGIN: 2,
        FORM_MENU: 3,
        FORM_USUARIO: 4,
        FORM_SEXO: 6,
        FORM_ESTADO_CIVIL: 7,
        FORM_PRODUCTO: 10,
        FORM_CIUDAD: 11,
        FORM_COBERTURA: 12,
        FORM_COMPANIA: 13,
        FORM_DOCUMENTO_FISCAL: 14,
        FORM_ESTADO: 15,
        FORM_GRUPO_COBERTURA: 16,
        FORM_IDIOMA: 17,
        FORM_MONEDA: 18,
        FORM_PAIS: 19,
        FORM_PLAN: 21,
        FORM_RAMO: 22,
        FORM_TERRITORIO: 23,
        FORM_TIPO_CONTACTO: 24,
        FORM_TIPO_CORREO: 25,
        FORM_TIPO_TELEFONO: 26,
        FORM_ETIQUETA: 28,
        FORM_FORMULARIO: 29,
        FORM_RANGO_EDAD: 39,
        FORM_RANGO_TIEMPO: 40,
        FORM_ORIGEN_DESTINO: 43,
        FORM_CATEGORIA: 47,
        FORM_TARIFA: 51,
        FORM_TIPO_CAMBIO:52,
        FORM_COTIZACION_VIAJERO: 62,
        FORM_ANEXO: 65,
        FORM_DEPORTE: 69,
        FORM_VARIABLE: 71,
        FORM_COTIZACION: 72,
        FORM_METODO_PAGO: 74,
        FORM_VALIDAR_METODO_PAGO: 76,

        // VARIABLE
        LIST_VARIABLE: 'lst_variable',

        // LIST
        ID_LIST_MESSAGE: 1,
        LIST_MESSAGES: 'messages',
        ID_LIST_ESTATUS: 5,
        LIST_ESTATUS: 'lst_estatus',
        ID_LIST_SI_NO: 37,
        LIST_SI_NO: 'lst_si_no',
        ID_LIST_FORMATO_CATEGORIA: 38,
        LIST_FORMATO_CATEGORIA: 'lts_formato_categoria',
        ID_LIST_TIPO_COBERTURA: 55,
        LIST_TIPO_COBERTURA: 'lts_tipo_cobertura',
        ID_LIST_CALCULO_COSTO: 56,
        LIST_CALCULO_COSTO: 'lst_calculo_costo',
        ID_LIST_CALCULO_TARIFA: 57,
        LIST_CALCULO_TARIFA: 'lst_calculo_tarifa',
        ID_LIST_CALCULO_PVP: 58,
        LIST_CALCULO_PVP: 'lst_calculo_pvp',
        ID_LIST_TIPO_PLAN: 59,
        LIST_TIPO_PLAN: 'lst_tipo_plan',
        ID_LIST_TIPO_ORIGEN_DESTINO: 60,
        LIST_TIPO_ORIGEN_DESTINO: 'lst_tipo_origen_destino',
        ID_LIST_TIPO_RANGO_TIEMPO: 61,
        LIST_TIPO_RANGO_TIEMPO: 'lst_tipo_rango_tiempo',
        ID_LIST_FIJO_OPCIONAL: 63,
        LIST_FIJO_OPCIONAL: 'lst_fijo_opcional',
        ID_LIST_CALCULO_COBERTURA: 64,
        LIST_CALCULO_COBERTURA: 'lst_calculo_cobertura',
        ID_LIST_CALCULO_SA_COBERTURA: 66,
        LIST_CALCULO_SA_COBERTURA: 'lst_calculo_sa_cobertura',
        ID_LIST_TIPO_SEGURO: 67,
        LIST_TIPO_SEGURO: 'lst_tipo_seguro',
        ID_LIST_CALCULO_FACTOR: 68,
        LIST_CALCULO_FACTOR: 'lst_calculo_factor',
        ID_LIST_RIESGO: 70,
        LIST_RIESGO: 'lst_riesgo',
        ID_LIST_PENDIENTE: 73,
        LIST_PENDIENTE: 'lst_pendiente',        
        ID_LIST_TIPO_VALIDACION: 75,
        LIST_TIPO_VALIDACION: 'lst_tipo_validacion',  

        // VARIABLE INITIALIZATION
        MESSAGES: { msg_error_3: "Error de conexión al servidor",
                    data: []
                  }
    },        
    mutations: {
        setMessages (state, messagesList) {
            state.MESSAGES = messagesList;
        },
        setCurrentRecord (state, newCurrentRecord) {
            state.currentRecord = newCurrentRecord;
        }
    }
})


// WEBPACK FOOTER //
// ./src/config/store.js